import { rankWith, isControl } from '@jsonforms/core';
import type {
  UISchemaElement,
  JsonSchema,
  TesterContext,
} from '@jsonforms/core';

export const additionalVocabTester = rankWith(
  10,
  (uischema: UISchemaElement, schema: JsonSchema, context: TesterContext) => {
    if (!isControl(uischema)) return false;

    const path = uischema.scope;
    const propName = path.split('/').pop();
    const propertySchema = context.rootSchema?.properties?.[propName ?? ''];

    return (
      propName === 'additional_vocab' &&
      propertySchema?.type === 'array' &&
      (propertySchema as any)?.['x-widget'] === 'additional-vocab-editor'
    );
  }
);
